import { regex } from 'arkregex';
import { z } from 'zod';

/**
 * RFC 4122 compatible UUID matcher that allows any version (v1–v8) while
 * preserving the canonical variant bits. Zod's built-in `.uuid()` helper
 * currently rejects v7 identifiers, so we share this ArkRegex-powered schema
 * to validate the UUIDs emitted by `generateUuid()`.
 */
export const UUID_PATTERN = regex.as('^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$', 'i');

export const UuidSchema = z.string().regex(UUID_PATTERN, 'Invalid UUID').describe('UUID (v1–v8)');

export type Uuid = z.infer<typeof UuidSchema>;
